import PagePolicy from "component/page/page_policy";
import SEOHelmet from "component/seo/seo_helmet";
import React from "react";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DataPrivacy = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <div className="min-h-[100vh] bg-gray-200 sm:p-[8px] lg:p-[32px]">
      <div class="mx-auto max-w-4xl px-1 py-12 sm:px-0 md:py-16 lg:px-8">
        <PagePolicy />
      </div>
      <SEOHelmet title="QUY CHẾ BẢO VỆ DỮ LIỆU CÁ NHÂN - Dịch Vụ Chuyển Âm Support | Chuyển Âm Thanh Sang Word bằng AI" />
    </div>
  );
};
export default DataPrivacy;
